module.exports = {
  Main: require('./lib/layout/Main').default,
  Header: require('./lib/layout/Header').default,
  Container: require('./lib/layout/Container').default,
  Grid: require('./lib/layout/Grid').default,
  Cell: require('./lib/layout/Grid').Cell,
  Offset: require('./lib/layout/Grid').Offset,
  Footer: require('./lib/layout/Footer').default,
};
